<article>
  @if(isLoader) {
    <div class="fixed inset-0 bg-opacity-50 backdrop-blur-sm flex items-center justify-center" style="z-index: 999;"
      role="status" aria-live="polite" aria-label="Loading profile">
      <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" />
    </div>
  }
  <app-breadcrumb [items]="['HEADER_LIST_EDIT_PROFILE' | translate]"></app-breadcrumb>

  <section class="px-[7rem] sm:px-[9.6rem]" aria-labelledby="edit-profile-heading">
    <div class="justify-self-center flex flex-col gap-[4rem] w-full sm:max-w-[124.8rem] mx-auto">

      <form #editProfile="ngForm" class="flex flex-col gap-[3rem]" (ngSubmit)="submitEditProfile()">
        <legend class="sr-only">Edit profile form</legend>
        <div class=" flex flex-col gap-[0.8rem]">
          <span id="edit-profile-heading" class="dsr-typescale-title-medium">{{'HEADER_LIST_EDIT_PROFILE' |
            translate}}</span>
        </div>

        <div class="-mt-10">
          <span class="dsr-typescale-body-small-prominent">&ast; {{'FORM_MANDATORY_TEXT' | translate}}</span>
        </div>

        <div class="items-center -mt-6 flex gap-4">
          <dsr-icon name="mail" class="size-[1.8rem]" color="black"></dsr-icon>
          <span class="dsr-typescale-body-small">
            {{profileInfo.userMail}}
          </span>
        </div>

        <div class="flex flex-col gap-[1.7rem] -mt-2">
          <span class="dsr-typescale-label-large-prominent !uppercase text-light-dsr-color-primary">
            {{'BILLING_ADDRESS_LABEL' | translate}}
          </span>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_FIRSTNAME_LABEL' | translate}}</mat-label>
              <input matInput type="text" [(ngModel)]="profileInfo.firstName" id="firstName" name="firstName"
                #firstName="ngModel" maxlength="30" pattern="^[A-Za-z ]+$" required minlength="1" aria-required="true"
                [attr.aria-invalid]="firstName.invalid && firstName.touched" autocomplete="given-name" />
              @if(firstName.errors && firstName.touched) {
              <mat-error>{{'REGISTRATION_VALID_NAME_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_LASTNAME_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="lastName" name="lastName"
                [(ngModel)]="profileInfo.lastName" #lastName="ngModel" maxlength="30" pattern="^[A-Za-z ]+$" required
                minlength="1" aria-required="true" [attr.aria-invalid]="lastName.invalid && lastName.touched"
                autocomplete="family-name" />
              @if(lastName.errors && lastName.touched) {
              <mat-error>{{'REGISTRATION_VALID_NAME_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_COMPANY_NAME_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="companyName" name="companyName" required minlength="1" pattern="^[A-Za-z ]+$"
                [(ngModel)]="profileInfo.companyName" disabled
                placeholder="{{'FORM_COMPANY_NAME_PLACEHOLDER' | translate}}" maxlength="30" #companyName="ngModel"
                autocomplete="organization" />
              @if(companyName.errors && companyName.touched) {
              <mat-error>{{'REGISTRATION_LABEL_COMPANY_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            <div class="sm:col-span-2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{'FORM_ADDRESS_LABEL' | translate}}</mat-label>
                <input matInput [(ngModel)]="profileInfo.address" name="address"
                  placeholder="{{'FORM_ADDRESS_PLACEHOLDER' | translate}}" required
                  id="{{'FORM_ADDRESS_LABEL' | translate}}" type="text" #address="ngModel" aria-required="true"
                  [attr.aria-invalid]="address.invalid && address.touched" autocomplete="street-address" />
                @if((address.errors && address.touched) || notValidContent) {
                  <mat-error>{{'EDITPROFILE_ADDRESS_ERROR' | translate}}</mat-error>
                }
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_POSTAL_CODE_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="profilePostalCode" name="postalCode" required #postalCode="ngModel"
                [(ngModel)]="profileInfo.postalCode" [maxlength]="countryId === 73 ? 5 : 9"
                [pattern]="countryId === 73 ? '^\\d{5}$' : '^\\d{1,9}$'" aria-required="true"
                [attr.aria-invalid]="postalCode.invalid && postalCode.touched" autocomplete="postal-code" />
              @if(!postalCode.valid && postalCode.touched) {
              <mat-error>{{'REGISTRATION_LABEL_CODE_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_CITY_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="profileState" name="city" [(ngModel)]="profileInfo.city"
                maxlength="30" required minlength="1"
                #city="ngModel" pattern="^[A-Za-z ]+$" aria-required="true"
                [attr.aria-invalid]="city.invalid && city.touched" autocomplete="address-level2" />
              @if(city.errors && city.touched) {
              <mat-error>{{'REGISTRATION_LABEL_CITY_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_COUNTRY_LABEL' | translate}}</mat-label>
              <mat-select panelClass="profile-option-panel" [(ngModel)]="countryId"
                name="countryCode" id="{{'FORM_COUNTRY_LABEL' | translate}}" disabled>
                @for (country of countryList; track country) {
                <mat-option [value]="country.countryId">{{country.countryName}}</mat-option>
                }
              </mat-select>
              <dsr-icon matSuffix name="arrow-down-2" size="1.6rem"
                class="pointer-events-none" aria-hidden="true"></dsr-icon>
            </mat-form-field>
            
            <div class="grid grid-cols-1 sm:grid-cols-[minmax(0,1.2fr)_minmax(0,3.8fr)] gap-[2.4rem]">
              <div class="min-w-0">
                <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                  <mat-label>{{'FORM_DIALLING_CODE_LABEL' | translate}}</mat-label>
                  <input matInput type="text" class="dialCode" [(ngModel)]="diallingCode" name="diallingCode" readonly
                    disabled />
                </mat-form-field>
              </div>
              <div class="min-w-0">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_PHONE_LABEL' | translate}}</mat-label>
                  <input matInput [(ngModel)]="profileInfo.mobileNumber" name="mobileNumber" required
                    pattern="^(?!\s*$)\d{4,13}$" placeholder="{{'FORM_PHONE_PLACEHOLDER' | translate}}"
                    id="{{'FORM_PHONE_LABEL' | translate}}" type="text" #mobileNumber="ngModel" aria-required="true"
                    [attr.aria-invalid]="mobileNumber.invalid && mobileNumber.touched" autocomplete="tel" />
                  @if(mobileNumber.errors && mobileNumber.touched) {
                  <mat-error>{{'REGISTRATION_LABEL_MOBILE_ERROR' | translate}}</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_LANGUAGE_LABEL' | translate}}</mat-label>
              <mat-select panelClass="profile-option-panel" placeholder="{{'FORM_LANGUAGE_PLACEHOLDER' | translate}}"
                [(ngModel)]="profileInfo.languageCode" id="language" name="language" #languageControl="ngModel"
                required aria-required="true">
                @for (lang of languageList; track lang) {
                <mat-option [value]="lang.langCode">{{lang.langName}}</mat-option>
                }
              </mat-select>
              <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                class="pointer-events-none" aria-hidden="true"></dsr-icon>
              @if(!languageControl.valid && languageControl.touched) {
              <mat-error>{{'REGISTRATION_LABEL_LANGUAGE_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{'REGISTRATION_LABEL_CONSENT' | translate}}</mat-label>
                <mat-select panelClass="profile-option-panel" placeholder="{{'REGISTRATION_LABEL_PLACEHOLDER' | translate}}" name="consent"
                  [(ngModel)]="consent" id="{{'REGISTRATION_LABEL_CONSENT' | translate}}" #contactConsent="ngModel"
                  required>
                  <mat-option value="yes">Yes</mat-option>
                  <mat-option value="no">No</mat-option>
                </mat-select>
                <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                  class="pointer-events-none" aria-hidden="true"></dsr-icon>
              </mat-form-field>
            </div>
            
            @if((this.countryId === 73 || this.countryId === 85 || this.countryId === 135 || this.countryId === 180 ))
            {
            <div class="sm:col-span-1">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{'REG_COMPANY_LABEL' | translate}}</mat-label>
                <input matInput type="text" id="regNumber" name="companyNumber" [(ngModel)]="profileInfo.registerNumber"
                  placeholder="{{'REG_COMPANY_PLACEHOLDER' | translate}}" maxlength="50" minlength="1" disabled
                  #regNumber="ngModel" autocomplete="off"
                  [attr.aria-invalid]="regNumber.invalid && regNumber.touched" />
                @if(regNumber.errors && regNumber.touched) {
                <mat-error>{{'REG_COMPANY_ERROR' | translate}}</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            <!-- retirer e-invoicing qui est à la fin -->
             
            @if(showVatField) {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'REGISTRATION_LABEL_VAT' | translate}}</mat-label>
              <input matInput type="text" [(ngModel)]="vatValue" id="vatNumber" name="vatNumber" maxlength="15"
                #vatNumber="ngModel" class="displayInline" placeholder="{{'VAT_PLACEHOLDER'| translate}}"
                (ngModelChange)="vatNumberChanged()" autocomplete="off" disabled />
              @if(vatNumber.errors && vatNumber.touched) {
              <mat-error>Enter valid VAT number</mat-error>
              }
            </mat-form-field>
            }
            @if((this.countryId === 73 || this.countryId === 85 || this.countryId === 135 || this.countryId === 180 )
            && (accountId === 1 || accountId === 3)) {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>SIREN</mat-label> 
              <input (ngModelChange)="appendToEinvoiceValue()" matInput type="text" [(ngModel)]="profileInfo.siren" id="siren" name="siren" #siren="ngModel" required
                autocomplete="off" pattern="^\d{9}$" maxlength="9" />
              @if(!siren.valid && siren.touched) {
              <mat-error>{{'REGISTRATION_VALID_SIREN_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            }
            @if((this.countryId === 73 || this.countryId === 85 || this.countryId === 135 || this.countryId === 180 )
            && (accountId === 1 || accountId === 3 || accountId === 7)) {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>SIRET</mat-label>
              <input (ngModelChange)="appendToEinvoiceValue()" matInput type="text" [(ngModel)]="profileInfo.siret" id="siret" name="siret" #siret="ngModel" required
                autocomplete="off" pattern="^\d{14}$" maxlength="14" />
              @if(!siret.valid && siret.touched) {
              <mat-error>{{'REGISTRATION_VALID_SIRET_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            }
            
          </div>
        </div>

        @if(accountId === 2) {
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'FORM_REQUEST_OBJECT_LABEL' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="profileInfo.message"
              placeholder="{{ 'FORM_REQUEST_OBJECT_PLACEHOLDER' | translate }}"
              id="message" name="message" #message="ngModel" maxlength="300" rows="4" cols="40"
              autocomplete="off" required></textarea>
            @if(!message.valid && message.touched) {
              <mat-error>{{ 'REGISTRATION_LABEL_MESSAGE_ERROR' | translate }}</mat-error>
            }
          </mat-form-field>
        }

        @if((this.countryId === 73 || this.countryId === 85 || this.countryId === 135 || this.countryId === 180 )) {
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'E-INVOICING_LABEL' | translate}}</mat-label>
              <mat-select (selectionChange)="appendToEinvoiceValue()" panelClass="profile-option-panel" [(ngModel)]="eInvoice" name="eInvoice" id="{{'E-INVOICING_LABEL' | translate}}">
                @for (option of einvoicingList; track option) {
                <mat-option [value]="option.value">{{option.label}}</mat-option>
                }
              </mat-select>
              <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                class="pointer-events-none" aria-hidden="true"></dsr-icon>
            </mat-form-field>
            @if(eInvoice === 'SRSTRC') {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'ROUTING_CODE_LABEL' | translate}}</mat-label>
              <input matInput type="text" (ngModelChange)="appendToEinvoiceValue()" id="routingCode" name="routingCode" [(ngModel)]="profileInfo.routingCode"
                maxlength="30" required minlength="1"
                #routingcode="ngModel" aria-required="true" autocomplete="off"
                [attr.aria-invalid]="routingcode.invalid && routingcode.touched" />
              @if(routingcode.errors && routingcode.touched) {
              <mat-error>{{'REGISTRATION_LABEL_ROUTING_CODE_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            }
            @if(eInvoice === 'SRSF') {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'SUFFIX_LABEL' | translate}}</mat-label>
              <input (ngModelChange)="appendToEinvoiceValue()" matInput type="text" id="suffix" name="suffix" [(ngModel)]="profileInfo.suffix"
                [maxlength]="30" required minlength="1"
                #suffix="ngModel" aria-required="true" autocomplete="off"
                [attr.aria-invalid]="suffix.invalid && suffix.touched" />
              @if(!suffix.valid && suffix.touched) {
              <mat-error>{{'REGISTRATION_LABEL_SUFFIX_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            }
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'E-INVOICE_VALIDATE_LABEL' | translate}}</mat-label>
              <input matInput type="text" [(ngModel)]="EInvoiceValue" id="einvoiceValue" name="eInvoiceValue"
                #eInvoiceModel="ngModel" required autocomplete="off" readonly />
              <dsr-icon matSuffix [ngClass]="{'!bg-[lawngreen]': einvoiceAddressLineVerified, '!bg-[#000000]': !einvoiceAddressLineVerified }"
                  class="cursor-pointer" (click)="validateEinvoiceAddressLine()" [name]="einvoiceAddressLineVerified ? 'confirm-2' : 'refresh'" alt="verify E-Invoice"   
                  matTooltip="verify E-Invoice"></dsr-icon>
              @if(einvoiceAddressLineError && !einvoiceAddressLineVerified) {
                <mat-hint class="!text-red-500 !font-[600] !text-wrap">
                  @switch (eInvoice) {
                    @case ('SRST') { {{ 'EINVOICE_SIREN_SIRET_ERROR' | translate }} }
                    @case ('SRSTRC') { {{ 'EINVOICE_SIREN_SIRET_ROUTING_ERROR' | translate }} }
                    @case ('SRSF') { {{ 'EINVOICE_SIREN_SUFFIX_ERROR' | translate }} }
                    @default { {{ 'EINVOICE_SIREN_ERROR' | translate }} }
                  }
                </mat-hint>
                }
            </mat-form-field>

          </div>
        }

        <div class="flex flex-col gap-[1.7rem]">
          <span class="dsr-typescale-label-large-prominent !uppercase text-light-dsr-color-primary">
            {{'DELIVERY_ADDRESS_LABEL' | translate}}
          </span>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_FIRSTNAME_LABEL' | translate}}</mat-label>
              <input matInput type="text" [(ngModel)]="profileInfo.deliveryFirstName" id="deliveryFirstName"
                name="deliveryFirstName" #deliveryFirstName="ngModel" maxlength="30" pattern="^[A-Za-z ]+$" required
                minlength="1" aria-required="true"
                [attr.aria-invalid]="deliveryFirstName.invalid && deliveryFirstName.touched"
                autocomplete="given-name" />
              @if(deliveryFirstName.errors && deliveryFirstName.touched) {
                <mat-error>{{'REGISTRATION_VALID_NAME_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_LASTNAME_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="deliveryLastName" name="deliveryLastName"
                [(ngModel)]="profileInfo.deliveryLastName"
                #deliveryLastName="ngModel" maxlength="30" pattern="^[A-Za-z ]+$" required minlength="1"
                aria-required="true" [attr.aria-invalid]="deliveryLastName.invalid && deliveryLastName.touched"
                autocomplete="family-name" />
              @if(deliveryLastName.errors && deliveryLastName.touched) {
                <mat-error>{{'REGISTRATION_VALID_NAME_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_COMPANY_NAME_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="deliveryCompanyName" name="deliveryCompanyName" required minlength="1"
                pattern="^[A-Za-z ]+$" [(ngModel)]="profileInfo.deliveryCompanyName"
                placeholder="{{'FORM_COMPANY_NAME_PLACEHOLDER' | translate}}" maxlength="30"
                #deliveryCompanyName="ngModel" disabled autocomplete="organization" />
              @if(deliveryCompanyName.errors && deliveryCompanyName.touched) {
                <mat-error>{{'REGISTRATION_LABEL_COMPANY_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            
            <div class="sm:col-span-2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{'FORM_ADDRESS_LABEL' | translate}}</mat-label>
                <input matInput [(ngModel)]="profileInfo.deliveryAddress" name="deliveryAddress" #deliveryAddress="ngModel"
                  required placeholder="{{'FORM_ADDRESS_PLACEHOLDER' | translate}}"
                  id="{{'FORM_ADDRESS_LABEL' | translate}}" type="text" aria-required="true"
                  [attr.aria-invalid]="deliveryAddress.invalid && deliveryAddress.touched"
                  autocomplete="street-address" />
                @if((deliveryAddress.errors && deliveryAddress.touched) || notValidDeliveryContent) {
                  <mat-error>{{'EDITPROFILE_ADDRESS_ERROR' | translate}}</mat-error>
                }
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_POSTAL_CODE_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="deliveryPostalCode" name="deliveryPostalCode" required
                #deliveryPostalCode="ngModel" [(ngModel)]="profileInfo.deliveryPostalCode"
                [maxlength]="deliveryCountryId === 73 ? 5 : 9"
                [pattern]="deliveryCountryId === 73 ? '^\\d{5}$' : '^[a-zA-Z0-9]{1,9}$'" aria-required="true"
                [attr.aria-invalid]="deliveryPostalCode.invalid && deliveryPostalCode.touched"
                autocomplete="postal-code" />
              @if(deliveryPostalCode.errors && deliveryPostalCode.touched) {
                <mat-error>{{'REGISTRATION_LABEL_CODE_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_CITY_LABEL' | translate}}</mat-label>
              <input matInput type="text" id="deliveryCity" name="deliveryCity" [(ngModel)]="profileInfo.deliveryCity"
                maxlength="30" required minlength="1"
                #deliveryCity="ngModel" pattern="^[A-Za-z ]+$" aria-required="true"
                [attr.aria-invalid]="deliveryCity.invalid && deliveryCity.touched" autocomplete="address-level2" />
              @if(deliveryCity.errors && deliveryCity.touched) {
                <mat-error>{{'REGISTRATION_LABEL_CITY_ERROR' | translate}}</mat-error>
              }
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'FORM_COUNTRY_LABEL' | translate}}</mat-label>
              <mat-select panelClass="profile-option-panel" name="deliveryCountryId"
                [(ngModel)]="deliveryCountryId" #deliveryCountryModel="ngModel"
                id="{{'FORM_COUNTRY_LABEL' | translate}}" (selectionChange)="countryChange($event.value)">
                @for (country of countryList; track country) {
                  <mat-option [value]="country.countryId">{{country.countryName}}</mat-option>
                }
              </mat-select>
              <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                class="pointer-events-none" aria-hidden="true"></dsr-icon>
            </mat-form-field>
            

            <div class="grid grid-cols-1 sm:grid-cols-[minmax(0,1.2fr)_minmax(0,3.8fr)] gap-[2.4rem] sm:col-span-1">
              <div class="min-w-0">
                <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                  <mat-label>{{'FORM_DIALLING_CODE_LABEL' | translate}}</mat-label>
                  <input matInput type="text" class="dialCode" [(ngModel)]="deliveryDiallingCode" name="deliveryDiallingCode"
                    readonly disabled />
                </mat-form-field>
              </div>
              <div class="min-w-0">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{'FORM_PHONE_LABEL' | translate}}</mat-label>
                  <input matInput type="text" class="mobileNumber" id="deliveryMobileNumber" name="deliveryMobileNumber"
                    [ngModel]="profileInfo.deliveryMobileNumber" placeholder="{{'FORM_PHONE_PLACEHOLDER' | translate}}"
                    required #deliveryMobileNumber="ngModel" (ngModelChange)="profileInfo.deliveryMobileNumber=$event"
                    pattern="^(?!\s*$)\d{4,13}$" aria-required="true"
                    [attr.aria-invalid]="deliveryMobileNumber.invalid && deliveryMobileNumber.touched"
                    autocomplete="tel" />
                  @if(deliveryMobileNumber.errors && deliveryMobileNumber.touched) {
                    <mat-error>{{'REGISTRATION_LABEL_MOBILE_ERROR' | translate}}</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div role="group" aria-label="Profile form actions" class="flex flex-col sm:flex-row gap-[1.6rem] font-[600]">
          <button mat-flat-button class="" type="submit"
            [disabled]="!editProfile.valid || !editProfile.dirty || !isFormChanged() || einvoiceAddressLineVerified" [attr.aria-busy]="isLoader">
            <span class="">{{'CONFIRM_BUTTON' | translate}}</span></button>

          <button mat-stroked-button color="primary" class="" type="button" (click)="backToHome()"
            aria-label="Cancel and return to home">
            <span class="">{{'CANCEL_BUTTON' | translate}}</span></button>
        </div>
      </form>

      <div class="flex flex-col gap-[0.6rem] mb-[12.8rem] w-full sm:w-[124.8rem]">
        <span class="dsr-typescale-body-small !uppercase">{{'PERSONAL_INFO_HEADER' | translate}}</span>
        <span class="dsr-typescale-body-small">{{'PERSONAL_INFO_TEXT_1' | translate}}
          <a target="_blank" class="dsr-hyperlink" href="https://www.renault.fr/vos-droits.html"
            rel="noopener noreferrer" aria-label="Renault privacy rights page (opens in new tab)">
            <span
              class="!border-dotted !border-b-2 dsr-typescale-body-small-prominent">https://www.renault.fr/vos-droits.html</span></a>
          {{'PERSONAL_INFO_TEXT_2' | translate}} <a [href]="dataPrivacyDoc" class="dsr-hyperlink" target="_blank"
            aria-label="Personal data information"><span
              class="!border-dotted !border-b-2 dsr-typescale-body-small-prominent">{{'PERSONAL_DATA_LINK' | translate}}</span></a>
        </span>
      </div>

    </div>
  </section>

</article>